import React from "react";

import { formatMoney } from "../detailMappers";

const RefillVolumeField = ({ entry, options, onSelect }) => {
  if (entry.refillType === "full") {
    return (
      <select value={entry.cylinderVolume ?? ""} disabled aria-label="Refill volume">
        <option value={entry.cylinderVolume ?? ""}>
          {entry.cylinderVolume !== null ? `${entry.cylinderVolume} Kg` : "—"}
        </option>
      </select>
    );
  }

  return (
    <select
      value={entry.refillVolume ?? ""}
      onChange={(event) => onSelect(entry.id, Number(event.target.value))}
      aria-label="Refill volume in kg"
    >
      {!options.length && <option value="">—</option>}

      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

const CustomRefillEntry = ({
  entry,
  index,
  cylinderOptions,
  materialOptions,
  refillVolumeOptions,
  onSelectCylinder,
  onSelectMaterial,
  onSelectRefillType,
  onSelectRefillVolume,
  onRemove,
}) => (
  <div className="sy-refill-entry">
    {index > 0 && (
      <div className="sy-refill-entry-head">
        <span>Custom fill {index + 1}</span>

        <button
          type="button"
          className="sy-refill-remove"
          onClick={() => onRemove(entry.id)}
          aria-label="Remove this custom fill"
        >
          Remove
        </button>
      </div>
    )}

    <div className="sy-refill-grid">
      <label className="sy-refill-field">
        <span>Cylinder Type</span>

        <select
          value={entry.materialId ?? ""}
          disabled={!materialOptions.length}
          onChange={(event) => onSelectMaterial(entry.id, event.target.value)}
        >
          {!materialOptions.length && <option value="">—</option>}

          {materialOptions.map((option) => (
            <option key={option.id} value={option.id}>
              {option.label}
            </option>
          ))}
        </select>
      </label>

      <label className="sy-refill-field">
        <span>Cylinder Volume</span>

        <select
          value={entry.productId ?? ""}
          onChange={(event) => onSelectCylinder(entry.id, event.target.value)}
        >
          {cylinderOptions.map((option) => (
            <option key={option.id} value={option.id}>
              {option.label}
            </option>
          ))}
        </select>
      </label>

      <label className="sy-refill-field">
        <span>Refill Type</span>

        <select
          value={entry.refillType}
          onChange={(event) => onSelectRefillType(entry.id, event.target.value)}
        >
          <option value="full">Full</option>
          <option value="partial">Partial</option>
        </select>
      </label>

      <label className="sy-refill-field">
        <span>Refill Volume (Kg)</span>

        <RefillVolumeField
          entry={entry}
          options={refillVolumeOptions}
          onSelect={onSelectRefillVolume}
        />
      </label>
    </div>

    <div className="sy-refill-amount">
      <span>Amount</span>

      <b>
        {entry.quoting
          ? "Calculating…"
          : Number.isFinite(entry.amount)
          ? formatMoney(entry.amount, entry.currency)
          : "—"}
      </b>
    </div>

    {entry.quoteError && <p className="sy-refill-error">{entry.quoteError}</p>}
  </div>
);

const CustomRefillForm = ({
  entries,
  cylinderOptions,
  materialOptionsOf,
  refillVolumeOptionsOf,
  total,
  onSelectCylinder,
  onSelectMaterial,
  onSelectRefillType,
  onSelectRefillVolume,
  onAddEntry,
  onRemoveEntry,
}) => (
  <div className="sy-refill-form">
    {entries.map((entry, index) => (
      <CustomRefillEntry
        key={entry.id}
        entry={entry}
        index={index}
        cylinderOptions={cylinderOptions}
        materialOptions={materialOptionsOf(entry.id)}
        refillVolumeOptions={refillVolumeOptionsOf(entry.id)}
        onSelectCylinder={onSelectCylinder}
        onSelectMaterial={onSelectMaterial}
        onSelectRefillType={onSelectRefillType}
        onSelectRefillVolume={onSelectRefillVolume}
        onRemove={onRemoveEntry}
      />
    ))}

    <div className="sy-refill-footer-row">
      <button type="button" className="sy-refill-add" onClick={onAddEntry}>
        + Add More
      </button>

      {total && (
        <span className="sy-refill-total-inline">
          Total <b>{formatMoney(total.amount, total.currency)}</b>
        </span>
      )}
    </div>
  </div>
);

export default CustomRefillForm;
